/**
 * Landing Page Content Configuration
 *
 * Edit this file to update all marketing content on the landing page.
 * No React knowledge required — just update the text, numbers, and descriptions.
 */

export const landingContent = {
  header: {
    brandName: 'QxProveIt',
    tagline: 'Where Quality means Prove It',
    ctaButtons: {
      signIn: 'Sign In',
      getStarted: 'Get Started Free',
    },
  },

  hero: {
    headline: 'Modern Test Management',
    headlineHighlight: 'Built for Teams',
    tagline: 'Where Quality means Prove It',
    subheadline:
      'QxProveIt is a comprehensive SaaS platform for test management, execution, ' +
      'and analytics. Streamline your QA process and deliver quality software faster.',
    ctaButtons: {
      primary: 'Start Free Trial',
      secondary: 'Watch Demo',
    },
    heroImage:
      'https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxkYXRhJTIwYW5hbHl0aWNzJTIwZGFzaGJvYXJkfGVufDF8fHx8MTc2MjI1MzE1OXww&ixlib=rb-4.1.0&q=80&w=1080',
  },

  features: {
    sectionTitle: 'Everything You Need',
    sectionSubtitle: 'Powerful features to streamline your testing workflow',
    items: [
      {
        title: 'Test Management',
        description: 'Comprehensive test case management with powerful test repository',
        icon: 'FileCheck',
      },
      {
        title: 'Fast Execution',
        description: 'Execute tests quickly and track results in real-time',
        icon: 'Zap',
      },
      {
        title: 'Rich Analytics',
        description: 'Detailed reports and dashboards for data-driven decisions',
        icon: 'BarChart3',
      },
      {
        title: 'Team Collaboration',
        description: 'Built for teams with role-based access and real-time updates',
        icon: 'Users',
      },
      {
        title: 'Security & Compliance',
        description: 'Enterprise-grade security with SOC 2, FDA, and DoD compliance',
        icon: 'Shield',
      },
      {
        title: 'Requirements Traceability',
        description: 'Full traceability from requirements to test cases to defects',
        icon: 'CheckCircle2',
      },
    ],
  },

  stats: [
    { value: '10M+', label: 'Tests Executed' },
    { value: '99.9%', label: 'Uptime SLA' },
    { value: '500+', label: 'Companies' },
    { value: '50%', label: 'Faster QA Cycles' },
  ],

  showcase: {
    sectionTitle: 'See It In Action',
    sectionSubtitle: 'Powerful tools designed for modern QA teams',
    images: [
      {
        url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800',
        alt: 'Dashboard Analytics',
      },
      {
        url: 'https://images.unsplash.com/photo-1504868584819-f8e8b4b6d7e3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=800',
        alt: 'Test Management Interface',
      },
    ],
  },

  cta: {
    headline: 'Ready to Transform Your QA Process?',
    subheadline: 'Join hundreds of teams already using QxProveIt',
    buttonText: 'Start Free Trial',
    disclaimer: 'No credit card required. 14-day free trial.',
  },

  footer: {
    copyright: '© 2025 MCX Services, LLC. All rights reserved.',
    tagline: 'Where Quality means Prove It',
    links: [
      { text: 'Privacy Policy', url: '#' },
      { text: 'Terms of Service', url: '#' },
      { text: 'Contact', url: '#' },
    ],
  },
}
